var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18499",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18499",
    transform: "translate(-32 -331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-activity-history",
    d: "M3,2V16.412a2.867,2.867,0,0,0,2.62,3.057H16.975a2.867,2.867,0,0,0,2.62-3.057,2.867,2.867,0,0,0-2.62-3.057V2h-2.62a.873.873,0,1,1-1.747,0H10.861A.873.873,0,0,1,9.114,2H7.367A.873.873,0,1,1,5.62,2ZM5.62,5.494h8.734V7.241H5.62Zm0,3.494h6.114v1.747H5.62Zm0,6.114c.465,0,.873.612.873,1.31s-.409,1.31-.873,1.31-.873-.612-.873-1.31S5.156,15.1,5.62,15.1Zm2.358,0h9c.465,0,.873.612.873,1.31s-.409,1.31-.873,1.31h-9a3.4,3.4,0,0,0,0-2.62Z",
    transform: "translate(31 330)",
    fill: "#A59785"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_11151",
    "data-name": "\\u9577\\u65B9\\u5F62 11151",
    width: 20,
    height: 20,
    transform: "translate(32 331)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice_icon.9ec0b35f54aa9c60a09babaa6890ca07.svg";
export { ForwardRef as ReactComponent };